import {
    UPDATE_DEPRECIATION_YEAR_BEGIN,
    UPDATE_DEPRECIATION_YEAR_SUCCESS,
    UPDATE_DEPRECIATION_YEAR_FAILURE,
    UPDATE_DEPRECIATION_YEAR_CLEAR
  } from './constants';
  import { BFFAgent } from 'BFFAgent';

  export function updateDepreciationYear(rowToEdit) {
    return async(dispatch) => { 
      dispatch({
        type: UPDATE_DEPRECIATION_YEAR_BEGIN,
      });
      try{
        const res = await BFFAgent.Datamasters.updateDepreciationYear(rowToEdit)
        
        dispatch({
            type: UPDATE_DEPRECIATION_YEAR_SUCCESS,
            data: res,
        });
      }catch(error){
        dispatch({
            type: UPDATE_DEPRECIATION_YEAR_FAILURE,
            data: error,
        });
      }
    }
    }
  
    export function clearUpdateDepreciationYear() {
      return dispatch => {
        dispatch({
          type: UPDATE_DEPRECIATION_YEAR_CLEAR,
        })
      }
    }
  
  
  export function reducer(state, action) {
    switch (action.type) {
      case UPDATE_DEPRECIATION_YEAR_CLEAR:
        return {
          ...state,
          updateDepreciationYearSuccess: null,
          updateDepreciationYearPending: null,
          updateDepreciationYearError: null,
        };

      case UPDATE_DEPRECIATION_YEAR_BEGIN:
        return {
          ...state,
          updateDepreciationYearSuccess: null,
          updateDepreciationYearPending: true,
          updateDepreciationYearError: null,
        };
  
      case UPDATE_DEPRECIATION_YEAR_SUCCESS:
        return {
          ...state,
          updateDepreciationYearSuccess: true,
          updateDepreciationYearPending: false,
          updateDepreciationYearError: null,
        };
  
      case UPDATE_DEPRECIATION_YEAR_FAILURE:
        return {
          ...state,
          updateDepreciationYearSuccess: false,
          updateDepreciationYearPending: false,
          updateDepreciationYearError: action.data,
        };
      default:
        return state;
    }
  }
  